import { QueryHookOptions, QueryResult, useQuery } from "@apollo/client";
import { baseUrl } from "createAbsolutePath";
import {
  AccountType,
  ActiveProfileDoc,
  ActiveProfileQuery,
  ActiveProfileQueryVariables,
} from "operations";
import { useMemo } from "react";
import { decodeNodeId } from "../../lib/Relay";

export const useActiveProfileQuery = (
  options?: QueryHookOptions<
    ActiveProfileQuery,
    ActiveProfileQueryVariables
  > & { decodeNodeIds?: boolean }
): QueryResult<ActiveProfileQuery, ActiveProfileQueryVariables> => {
  const results = useQuery(ActiveProfileDoc, options);

  if (
    !results.loading &&
    (results.error || results.data?.account.type !== AccountType.Retailer)
  ) {
    window.open(baseUrl, "_self");
  }

  const mappedData = useMemo(
    () =>
      results.data &&
      ({
        ...results.data,
        account: results.data?.account && decodeNodeId(results.data?.account),
        otherAccounts:
          results.data?.otherAccounts &&
          results.data?.otherAccounts.map(decodeNodeId),
        user: results.data?.user && decodeNodeId(results.data?.user),
      } as ActiveProfileQuery),
    [results]
  );

  return { ...results, data: mappedData };
};
